import React from "react";
import { Nav, Tab } from "react-bootstrap";
import { formatDate, formatStatus } from "../../../util/Helpers";
import { UserRelationshipsTable } from "./UserRelationshipsTable";
import { SocialPostsTab } from "./SocialPostsTab";
import { SocialSubscribers } from "./SocialSubscribers";
import { SocialSubscriptionsTable } from "./SocialSubscriptionsTable";
import { useGetSocialUserQuery } from "../../../../redux/apiSlice";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";


const SocialUserDetails = ({ details, tableRef }) => {
  
  const { isFetching, data } = useGetSocialUserQuery(details?.userId );
  return (
    <Tab.Container defaultActiveKey={""}>
      <div className={"d-flex flex-column px-0 h-100"}>
        <Nav
          className="d-flex w-100 px-6 border-bottom align-items-center bg-white position-sticky top-0"
          style={{
            height: "46px",
            zIndex: 1,
          }}
        >
          <Nav.Item>
            <Nav.Link className="px-3" eventKey={""}>
              <div>Profile</div>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link className="px-3" eventKey={"followers"}>
              <div>Followers</div>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link className="px-3" eventKey={"following"}>
              <div>Following</div>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link className="px-3" eventKey={"posts"}>
              <div>Posts</div>
            </Nav.Link>
          </Nav.Item>
          {details?.userLevel === "power" && (
            <Nav.Item>
              <Nav.Link className="px-3" eventKey={"subscribers"}>
                <div>Subscribers</div>
              </Nav.Link>
            </Nav.Item>
          )}
          <Nav.Item>
            <Nav.Link className="px-3" eventKey={"subscriptions"}>
              <div>Subscriptions</div>
            </Nav.Link>
          </Nav.Item>
        </Nav>
        <Tab.Content className={"flex-grow-1 px-5"}>
          <Tab.Pane eventKey={""}>
            {isFetching ? (
              <div
                className="h-100 d-flex flex-column align-items-center justify-content-center"
                style={{
                  minHeight: "300px",
                  textAlign: "center",
                }}
              >
                <div className="spinner spinner-primary spinner-lg mb-4"></div>
                <h6 className="text-muted">Loading social profile...</h6>
              </div>

            ) : data ? (
              <div className="p-4">
                 {/* Header Section */}
                <div className="d-flex align-items-center mb-8">
                    <div
                        className="symbol symbol-100 symbol-lg-120 symbol-circle symbol-light-primary overflow-hidden mr-6"
                    >
                         {data?.data?.imageUrl ? (
                            <img src={data?.data?.imageUrl} alt="User Avatar" style={{objectFit: 'cover'}} />
                         ) : (
                             <span className="symbol-label font-size-h1 font-weight-bold text-primary">
                                {data?.data?.displayName?.[0]?.toUpperCase() || "U"}
                             </span>
                         )}
                    </div>
                    <div className="d-flex flex-column">
                         <div className="font-weight-bold font-size-h3 text-dark-75 mb-1">
                             {data?.data?.displayName || "N/A"}
                         </div>
                         <div className="text-muted font-size-lg mb-2">
                            @{data?.data?.username || "N/A"}
                         </div>
                         <div>
                            {formatStatus(data?.data?.status)}
                         </div>
                    </div>
                </div>

                <div className="separator separator-dashed my-8"></div>

                {/* Stats Cards */}
                <h6 className="font-weight-bolder text-dark mb-4">Activity Stats</h6>
                <div className="row mb-8">
                     <div className="col-md-3 col-6 mb-4">
                        <div className="card card-custom bg-light-primary card-stretch gutter-b">
                            <div className="card-body p-4 text-center">
                                <span className="svg-icon svg-icon-3x svg-icon-primary mb-3">
                                   {/* Followers Icon - Users */}
                                   <img src={toAbsoluteUrl("/media/svg/icons/Communication/Group.svg")} alt="" style={{width: '32px', height: '32px'}} />
                                </span>
                                <div className="text-dark font-weight-bolder font-size-h4 mb-0">{data?.data?.followerCount || 0}</div>
                                <span className="text-muted font-weight-bold font-size-sm">Followers</span>
                            </div>
                        </div>
                     </div>
                     <div className="col-md-3 col-6 mb-4">
                        <div className="card card-custom bg-light-info card-stretch gutter-b">
                             <div className="card-body p-4 text-center">
                                <span className="svg-icon svg-icon-3x svg-icon-info mb-3">
                                    {/* Following Icon - Add User */}
                                     <img src={toAbsoluteUrl("/media/svg/icons/Communication/Add-user.svg")} alt="" style={{width: '32px', height: '32px'}} />
                                </span>
                                <div className="text-dark font-weight-bolder font-size-h4 mb-0">{data?.data?.followsCount || 0}</div>
                                <span className="text-muted font-weight-bold font-size-sm">Following</span>
                            </div>
                        </div>
                     </div>
                     <div className="col-md-3 col-6 mb-4">
                        <div className="card card-custom bg-light-success card-stretch gutter-b">
                             <div className="card-body p-4 text-center">
                                <span className="svg-icon svg-icon-3x svg-icon-success mb-3">
                                    {/* Posts Icon - Write */}
                                     <img src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")} alt="" style={{width: '32px', height: '32px'}} />
                                </span>
                                <div className="text-dark font-weight-bolder font-size-h4 mb-0">{data?.data?.postCount || 0}</div>
                                <span className="text-muted font-weight-bold font-size-sm">Posts</span>
                            </div>
                        </div>
                     </div>
                     <div className="col-md-3 col-6 mb-4">
                        <div className="card card-custom bg-light-warning card-stretch gutter-b">
                             <div className="card-body p-4 text-center">
                                <span className="svg-icon svg-icon-3x svg-icon-warning mb-3">
                                    {/* Transactions Icon - Dollar/Card */}
                                     <img src={toAbsoluteUrl("/media/svg/icons/Shopping/Credit-card.svg")} alt="" style={{width: '32px', height: '32px'}} />
                                </span>
                                <div className="text-dark font-weight-bolder font-size-h4 mb-0">{data?.data?.transactionCount || 0}</div>
                                <span className="text-muted font-weight-bold font-size-sm">Transactions</span>
                            </div>
                        </div>
                     </div>
                </div>

                <div className="separator separator-dashed my-8"></div>

                {/* Additional Details */}
                <h6 className="font-weight-bolder text-dark mb-4">Additional Information</h6>
                <div className="row">
                    <div className="col-md-4 mb-5">
                        <span className="text-muted font-weight-bold d-block mb-1">User Level</span>
                        <span className="font-weight-bolder font-size-lg text-dark">{data?.data?.userLevel || "N/A"}</span>
                    </div>
                    <div className="col-md-4 mb-5">
                         <span className="text-muted font-weight-bold d-block mb-1">Rating</span>
                         <span className="font-weight-bolder font-size-lg text-dark">{data?.data?.rating || "N/A"}</span>
                    </div>
                     <div className="col-md-4 mb-5">
                         <span className="text-muted font-weight-bold d-block mb-1">Profile Created</span>
                         <span className="font-weight-bolder font-size-lg text-dark">{formatDate(data?.data?.created)}</span>
                    </div>
                </div>

              </div>
            ) : (
              <div className="d-flex align-items-center justify-content-center" style={{minHeight: '200px'}}>
                  <h6 className="text-muted">No data available</h6>
              </div>
            )}
          </Tab.Pane>
          <Tab.Pane eventKey={"followers"} className={"h-100"}>
            <UserRelationshipsTable details={details} profileId={details?.profileId} side={"followers"} />
          </Tab.Pane>
          <Tab.Pane eventKey={"following"} className={"h-100"}>
            <UserRelationshipsTable details={details} profileId={details?.profileId} side={"following"} />
          </Tab.Pane>
          <Tab.Pane eventKey={"posts"} className={"h-100"}>
            <SocialPostsTab details={details} profileId={details?.profileId} />
          </Tab.Pane>
          {details?.userLevel === "power" && (
            <Tab.Pane eventKey={"subscribers"} className={"h-100"}>
              <SocialSubscribers details={details} />
            </Tab.Pane>
          )}
          <Tab.Pane eventKey={"subscriptions"} className={"h-100"}>
            <SocialSubscriptionsTable details={details} />
          </Tab.Pane>
        </Tab.Content>
      </div>
    </Tab.Container>
  );
};

export default SocialUserDetails;
